import * as React from 'react';

import PreviewItem from '../../Shared/PreviewItem';
import SettingPreview from '../../Shared/SettingPreview';
import type { CompanyFeatureFlagsEntry } from '../formModel';

interface Props {
	toggleEdit: () => void;
	workOrderNotifications: (Nullable<CompanyFeatureFlagsEntry>)[];
}

export default class AutomaticNotificationsPreview extends React.PureComponent<Props> {

	renderItem = (featureFlag: Nullable<CompanyFeatureFlagsEntry>, index: number): React.JSX.Element => {
		const _featureFlag = featureFlag ?? {} as CompanyFeatureFlagsEntry;
		return (
			<PreviewItem
				checked={!!_featureFlag.checked}
				hint={_featureFlag.hint}
				id={`accqa__notification-settings__automatic__${_featureFlag.key}`}
				indent={!!_featureFlag.indent}
				key={`${_featureFlag.label}${index}`}
				label={_featureFlag.label}
				showCheckbox={!!_featureFlag.showStatusIcon}
				value={_featureFlag.value ?? undefined}
			/>
		);
	};

	render() {
		const { toggleEdit, workOrderNotifications } = this.props;

		return (
			<SettingPreview
				buttonContext="notification-settings__automatic"
				containerId="accqa__notification-settings__automatic__container"
				toggleEdit={toggleEdit}
			>
				<div className="company-settings__info-segment">
					{
						workOrderNotifications.map((_featureFlag: CompanyFeatureFlagsEntry, _index: number) => (
							this.renderItem(_featureFlag, _index))
						)
					}
				</div>
			</SettingPreview>
		);
	}
}
